import React, { useState } from 'react';
import { Row, Col, } from 'react-bootstrap';
import RealTimeText from './real_time_text.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';

function ColRealTimeText({ realTimeText }) {
    return (        
        <Col style={{ height: "12vh" }}>
            <Row className="align-items-center">
                <RealTimeText text={realTimeText} />
            </Row>
        </Col>        
    )
}

export default ColRealTimeText;